// lib/config/index.ts
import { AppConfig } from "@cabukaka/types";

let _ENV: AppConfig;

export const initConfig = (config: AppConfig) => {
  _ENV = config;
};

// Utilise ceci partout dans ton code
export const getConfig = (): AppConfig => {
  if (!_ENV) {
    throw new Error("❌ Config not initialized. Call initConfig() in your app entry point.");
  }
  return _ENV;
};